module.exports = __webpack_public_path__ + "static/img/061日式料理菜单.6124f41.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/061日式料理菜单.jpg
// module id = SmOY
// module chunks = 0